import React, { useState, useEffect, useRef } from "react";
import herobg from "../../assets/images/homewallpapers/hero.jpg";
import Opening from "./components/opening/Opening";
import gsap from "gsap";
import { useLocation } from "react-router-dom";
import MobileNavbar from "../shared/navbar/MobileNavbar";
import hero from "../../assets/images/homewallpapers/hero.jpg";
import Hero from "./components/hero/Hero";
import About from "./components/about/About";
import Services from "./components/services/Services";
import Team from "./components/team/Team";
import Project from "./components/art/Project";
import Client from "./components/client/Client";
import Footer from "../shared/footer/Footer";
import ParticlesComponent from "../shared/navbar/ParticlesComponent";
import FluidSimulation from "fluid-simulation-react";
import Scene from "../shared/3d/Scene";
import Model from "../shared/3d/Model";
import Faq from "../shared/faq/Faq";
import Partners from "./components/partners/Partners";
import Careers from "./components/careers/Careers";
import HeroTwo from "./components/hero/HeroTwo";
import herobgcover from "../../assets/images/herobgcover.png";
import Testimonials from "./components/Testimonials";
function Home({
    data,
    pageName,
    setPageName,
    setNavbarVisible,
    setIsLoading,
    isLoading,
    setIsLargeScreen,
    isLargeScreen,
    isPage,
    setisPage,
    pageInView,
    setPageInView,
}) {
    const [scrollToComponent, setScrollToComponent] = useState("scene");

    const location = useLocation();
    const zIndexValue = -10;

    useEffect(() => {
        const scrollToElement = (elementId) => {
            const element = document.getElementById(elementId);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        };

        // Check if scrollToElement exists in the state after navigation
        if (location.state?.scrollToElement) {
            scrollToElement(location.state.scrollToElement);
        }
    }, [location.state]);
    // useEffect(() => {
    //     // Animation for entering the "mobileNavbar" page
    //     if (pageName === "mobileNavbar") {
    //         gsap.from("#mobileNavbar", {
    //             y: "-100%",
    //             opacity: 0,
    //             yoyo: true,
    //             duration: 1.5,
    //             ease: "power3.out",
    //         });
    //     } else if (pageName === "normal") {
    //         setIsLoading(true);
    //         gsap.from(".normal-page", {
    //             y: "-100%",
    //             opacity: 0,
    //             rotate: 180,

    //             yoyo: true,
    //             duration: 2,
    //             ease: "power2.out",
    //         });
    //     }
    // }, [pageName]);

    useEffect(() => {
        setInterval(() => {
            setIsLoading(false);
        }, 2000);
    }, []);

    // useEffect(() => {
    //     const scrollToElement = () => {
    //         const element = document.getElementById(scrollToComponent);
    //         console.log("scroll", scrollToComponent);
    //         if (element) {
    //             gsap.to(window, {
    //                 scrollTo: {
    //                     y: element.offsetTop,
    //                     offsetY: 100, // adjust this value as needed
    //                 },
    //                 ease: "power2.inOut",
    //             });
    //         }
    //     };

    //     scrollToElement();
    // }, [scrollToComponent]);

    // if (isLoading) {
    //     return <Opening handleNormal={handleNormal} />;
    // }

    return (
        <div className="   max-w-full  w-full mx-auto    ">
            {pageName === "normal" && (
                <div className="overflow-hidden ">
                    <div className="relative">
                        <Hero
                            isPage={isPage}
                            setisPage={setisPage}
                            setIsLargeScreen={setIsLargeScreen}
                            isLargeScreen={isLargeScreen}
                            setPageInView={setPageInView}
                            pageInView={pageInView}
                        />
                        <HeroTwo
                            isPage={isPage}
                            setisPage={setisPage}
                            data={data}
                            setIsLargeScreen={setIsLargeScreen}
                            isLargeScreen={isLargeScreen}
                            setPageInView={setPageInView}
                            pageInView={pageInView}
                        />
                        <div
                            data-depth="0.1"
                            className={`absolute inset-0  z-[0]`}
                        >
                            <img
                                src={herobgcover}
                                alt=""
                                className={` object-cover h-[70%] lg:h-full w-full `}
                            />
                        </div>{" "}
                        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent z-[-10]"></div>{" "}
                    </div>
                    <div className=" ">
                        <Project
                            data={data}
                            setIsLargeScreen={setIsLargeScreen}
                            isLargeScreen={isLargeScreen}
                            setPageInView={setPageInView}
                            pageInView={pageInView}
                        />
                    </div>
                                       <div className=" ">
                        <Testimonials
                            data={data}
                            setIsLargeScreen={setIsLargeScreen}
                            isLargeScreen={isLargeScreen}
                            setPageInView={setPageInView}
                            pageInView={pageInView}
                        />
                    </div>

                    <div className="">
                        <Careers
                            setPageInView={setPageInView}
                            pageInView={pageInView}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default Home;
